import { fetchVerification } from '@afterpaytouch/event-verify'
import { portalAction, PortalThunk } from '../types'
import {
  RegistrationData,
  VerifyRegistrationAuthorizationRequest,
  VerifyRegistrationMobileEventRequest,
  VerifyRegistrationSMSAuthorizationResponse,
} from '@afterpaytouch/registration'
import { verifyServiceApi } from '../api'
import { VERIFY_SERVICE_BASE_URL } from '../request'
import { registrationSelector } from './selectors'
import { getApPortalToken } from '../../utils/tokenStorage'

export const verifyRegistrationSMSAuthorization: PortalThunk<void, VerifyRegistrationSMSAuthorizationResponse> = portalAction(
  'registration/verify/mobile/sms/authz',
  async (_, thunk) => {
    const { id: registrationId, data } = registrationSelector(thunk.getState())

    const amplitudeSessionId = (await import('amplitude-js')).default.getInstance()?.getSessionId() || 0

    const request: VerifyRegistrationAuthorizationRequest = {
      registrationId: registrationId ?? '',
      amplitudeSessionId,
      consumer: data as RegistrationData,
      transactionToken: getApPortalToken() ?? '',
    }

    try {
      const result = await verifyServiceApi
        .post<VerifyRegistrationAuthorizationRequest, VerifyRegistrationSMSAuthorizationResponse>('/authz/sms', request)
        .catch((e) => {
          return {
            code: e.response.data.code,
            message: e.response.data.message,
          }
        })
      return result
    } catch (e: unknown) {
      const error = e as { response?: { data?: { code?: string; message?: string } } }
      return {
        code: error?.response?.data?.code || ('FAILED' as const),
        message: error?.response?.data?.message || ('UNKNOWN' as const),
      }
    }
  }
)

export const verifyRegistrationMobileSMSEvent: PortalThunk<VerifyRegistrationMobileEventRequest, void> = portalAction(
  'registration/verify/mobile/sms/delay',
  async (verifyRegistrationMobileEventRequest, thunk) => {
    const portalToken = getApPortalToken() ?? ''
    const { onSuccess, onWaiting, onError } = verifyRegistrationMobileEventRequest

    return await fetchVerification({
      url: encodeURI(`${VERIFY_SERVICE_BASE_URL}/sms/${portalToken}`),
      onSuccess: () => {
        onSuccess()
      },
      onError: (d) => {
        onError(d)
      },
      onWaiting: (d) => {
        onWaiting(d)
      },
    })
  }
)
